import { useEffect } from "react";
import { toast } from "sonner";

import { requestDisplaySettings } from "./displaySettingsRequest";
import {
  hasSeenDensityNotice,
  markDensityNoticeSeen,
  readStoredDensity
} from "./storage";

const NOTICE_DELAY_MS = 2500;
const NOTICE_DURATION_MS = 12000;

/**
 * A one-time note for people who never picked a density: the default is
 * Comfortable, and this tells them where the setting lives. It has a close
 * cross and a quiet "Display Settings" link, and deliberately no button that
 * pushes anyone toward Compact. It shows at most once per device, and never
 * to someone who already chose.
 */
export function useDensityNotice(enabled: boolean): void {
  useEffect(() => {
    if (!enabled || hasSeenDensityNotice() || readStoredDensity() !== null)
      return undefined;
    const timer = window.setTimeout(() => {
      markDensityNoticeSeen();
      toast("Text is a little larger now", {
        description:
          "You can change it anytime from the account menu under Display.",
        duration: NOTICE_DURATION_MS,
        closeButton: true,
        onDismiss: markDensityNoticeSeen,
        onAutoClose: markDensityNoticeSeen,
        classNames: {
          actionButton:
            "h-auto! bg-transparent! px-0! py-0! font-medium! text-fg-3! underline underline-offset-2 hover:text-fg!"
        },
        action: {
          label: "Display Settings",
          onClick: () => {
            markDensityNoticeSeen();
            requestDisplaySettings();
          }
        }
      });
    }, NOTICE_DELAY_MS);
    return () => window.clearTimeout(timer);
  }, [enabled]);
}
